import { render } from "./AdminBookingDetail.vue?vue&type=template&id=753645e2&scoped=true&ts=true&lang=true"
import script from "./AdminBookingDetail.vue?vue&type=script&lang=ts"
export * from "./AdminBookingDetail.vue?vue&type=script&lang=ts"

import "./AdminBookingDetail.vue?vue&type=style&index=0&id=753645e2&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753645e2"]])

export default __exports__